module.exports = __webpack_public_path__ + "img/logo.d50f9513.png";